import { Link } from "react-router-dom";
import { categories } from "@/mocks/homeContent";

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="font-heading text-lg font-semibold text-background-50 mb-4">
              AllChinaBuy<span className="text-primary-400">Spreadsheet</span>
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              Your structured sourcing system for China product data. Verified suppliers, updated pricing, and curated spreadsheets — all in one place.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              Product Categories
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              More Categories
            </h4>
            <ul className="space-y-2">
              {categories.slice(7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/allchinabuyspreadsheet-guide"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  Spreadsheet Guide
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  AllChinaBuy Sheet
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} AllChinaBuy.surf. All content is for informational and educational purposes only.
          </p>
          <p className="text-xs text-background-500">
            We do not sell products directly. Always verify suppliers independently.
          </p>
        </div>
      </div>
    </footer>
  );
}